<template>
  <div id="page" class="page">
    <div v-if="!isAppUpdated" class="app-loading">
      <img :src="logoImg" alt="Omint" />
      <p>Verificando atualizações...</p>
    </div>
    <template v-else>
      <form class="cover">
        <div class="form">
          <CFlex justifyContent="center" mb="50px">
            <img :src="logoLogin" alt="Omint" />
          </CFlex>

          <CFlex mb="3" justifyContent="center">
            <OmtTypography fontSize="22px" fontWeight="700" as="p1" color="var(--colors-light-primary-navy-blue)" mr="1"
              >Olá,</OmtTypography
            >
            <OmtTypography fontSize="22px" fontWeight="400" as="p1">é bom te ver aqui!</OmtTypography>
          </CFlex>
          <CFlex justifyContent="center">
            <OmtTypography as="h2-regular" mb="5" color="var(--colors-light-primary-gray2)"
              >Insira seus dados para acessar o APP</OmtTypography
            >
          </CFlex>
          <div class="form-group">
            <OmtInput
              v-model="input.username"
              data-cy="login"
              autocapitalize="none"
              autocomplete="username"
              placeholder="CPF"
              type="text"
              @input="toLowerCase"
              v-on:keydown.enter.prevent="checkEnter"
              borderColor="var(--colors-light-secondary-divider)"
              px="2"
              class="InputLogin"
            />
            <span v-show="input.username === ''" class="required">(obrigatório)</span>
          </div>

          <div class="form-group">
            <OmtInput
              v-model="input.password"
              data-cy="password"
              :type="passwordShow ? 'text' : 'password'"
              autocapitalize="off"
              :autocomplete="passwordShow ? 'off' : 'current-password'"
              autocorrect="off"
              placeholder="Senha"
              v-on:keyup="
                () => {
                  this.invalidPwd = false;
                }
              "
              v-on:keydown.enter.prevent="checkEnter"
              px="2"
              class="InputLogin"
            />
            <OmtIcons
              size="lg"
              :name="passwordShow ? 'eye-slash' : 'eye'"
              color="var(--colors-light-primary-navy-blue)"
              position="absolute"
              right=".5rem"
              zIndex="2"
              @click.prevent="passwordShow = !passwordShow"
            />
            <span v-show="input.password === ''" class="required">(obrigatório)</span>
          </div>
          <CFlex mt="5" mb="8" justifyContent="space-between">
            <CBox>
              <router-link to="/first-access/terms">
                <OmtTypography as="h3-bold" color="var(--colors-light-primary-navy-blue)" cursor="pointer">
                  Primeiro acesso
                </OmtTypography>
              </router-link>
            </CBox>
            <CBox>
              <router-link to="/forgot/reset">
                <OmtTypography as="h3-bold" color="var(--colors-light-primary-navy-blue)" cursor="pointer">
                  Esqueci minha senha
                </OmtTypography>
              </router-link>
            </CBox>
          </CFlex>
          <OmtButton
            variant="solid"
            width="100%"
            height="50px"
            border="0.5px solid var(--colors-light-secondary-divider)"
            borderRadius="40px"
            :disabled="isLoading"
            data-cy="button-entrar"
            @click.prevent.stop="login"
          >
            <OmtTypography as="h1-bold" color="white">Entrar</OmtTypography>
          </OmtButton>

          <CFlex v-if="credentials.length" mt="5" mb="8" justifyContent="center">
            <router-link to="/offlinecredential">
              <OmtTypography as="h3-bold" color="var(--colors-light-primary-navy-blue)" cursor="pointer">
                Credencial Offline
              </OmtTypography>
            </router-link>
          </CFlex>
          <CFlex v-if="shoudUseBiometric" mt="50px">
            <CBox justifyContent="center" textAlign="center" w="100%" @click="authenticateUser()">
              <OmtIcons size="lg" name="expand" color="var(--colors-light-primary-gray1)" />
              <OmtTypography as="h3-bold">Entrar<br />com biometria</OmtTypography>
            </CBox>
          </CFlex>
        </div>
      </form>

      <InstallPWA />
    </template>
    <LoginRefused :isOpen="openModalLoginRefused" :message="errorMessage" @close="closeModal" />
  </div>
</template>

<script>
import LoginRefused from "@/components/Organisms/Login/LoginRefused.vue";
import InstallPWA from "@/components/Molecules/InstallPWA";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { ROTA_BASE, ROTA_PADRAO, ROTA_VINCULOS, ROTA_OPTIN } from "@/utils/perfilRouteUtil";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import equalweb from "@/components/Organisms/Equalweb/mixin.js";
import { injectOnePixelImage, removeOnePixelImage } from "@/utils/utils";

export default {
  mixins: [equalweb],
  computed: {
    ...mapGetters("biometrics", ["onNative"]),
    ...mapState("saude", ["userId", "credentials", "mfa_key", "mfa_email", "mfa_telefone", "typeLogin"]),
    ...mapState("accessManagement", ["appLocked"]),
    ...mapState("biometrics", ["shoudUseBiometric", "isUserAuthenticated", "listenersRegistred"]),
    equalButtonStyle() {
      return "rigth: 125px; top: 85%; width: 80px; height: 80px; --indscale: 0.6; --indmaincolor: #102a46;";
    },
    iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    hasValidNextUrl() {
      return (
        this.$route.query.nextUrl &&
        this.$route.query.nextUrl !== ROTA_BASE &&
        this.$route.query.nextUrl !== ROTA_PADRAO &&
        this.$route.query.nextUrl !== ROTA_OPTIN &&
        this.$route.query.nextUrl !== ROTA_VINCULOS
      );
    },
    logoImg() {
      return process.env.VUE_APP_BASE_URL + "images/omint/logo-omint-app.png";
    },
    logoLogin() {
      return process.env.VUE_APP_BASE_URL + "images/omint/logo2023.png";
    },
    // Indica se existe um fluxo de autenticação em duas etapas pendente (MFA),
    // usado para evitar recarregar o PWA em momentos sensíveis (ex.: login via URL + MFA).
    hasPendingMfa() {
      return !!(this.mfa_key && (this.mfa_email || this.mfa_telefone));
    }
  },
  data() {
    return {
      isAppUpdated: false,
      passwordShow: false,
      openModalLoginRefused: false,
      errorMessage: undefined,
      input: {
        username: null,
        password: null
      },
      isLoading: true
    };
  },
  watch: {
    async isUserAuthenticated(authenticated) {
      if (!authenticated) return;
      await this.handleAuthenticatedUser();
    }
  },
  beforeDestroy() {
    removeOnePixelImage();
  },
  async mounted() {
    this.$root.$emit("hide-loading");

    injectOnePixelImage();

    if ("localhost:8080" !== document.location.host && (this.iOS || !this.onNative)) {
      try {
        const updated = await this.forceSWupdate();
        if (updated) {
          // Se há fluxo de MFA pendente (mfa_key + mfa_email + mfa_telefone),
          // não recarregamos agora para não perder contexto
          if (this.hasPendingMfa) {
            await this.initConfig();
          } else {
            // Fluxo normal: recarregar imediatamente
            globalThis.window.location.reload(true);
            setTimeout(() => this.initConfig(), 5000);
          }
        } else {
          await this.initConfig();
        }
      } catch (err) {
        console.error(err);
        setTimeout(() => this.initConfig(), 1000);
      }
    } else {
      await this.initConfig();
    }

    // se o usuario tiver mfa_key, mfa_email e mfa_telefone, redireciona para a pagina de verificação de MFA
    if (this.mfa_key && (this.mfa_email || this.mfa_telefone)) {
      this.$router.push({ path: "/verification", query: { nextUrl: this.$route.query.nextUrl } });
    }
  },
  methods: {
    ...mapActions(["resetContext"]),
    ...mapActions("saude", ["loginUser", "refreshContext", "forceSWupdate"]),
    ...mapMutations("saude", ["SET_MFA_INFOS"]),
    ...mapActions("biometrics", [
      "authenticateUser",
      "registerListeners",
      "setAuthenticated",
      "setUserAuthenticationState"
    ]),
    ...mapMutations("saude", ["LOGOUT_USER"]),
    async initConfig() {
      this.isAppUpdated = true;
      this.isLoading = false;
      this.$root.$emit("hide-loading");
      this.registerListeners();
      this.initEqualweb({
        ...this.defaultEqualwebButtonStyle,
        vPosition: [null, "30%"],
        scale: ["0.35", "0.35"]
      });
      if (this.userId && !this.appLocked) {
        await this.resetContext();
      }
      if (this.shoudUseBiometric && this.listenersRegistred) {
        setTimeout(() => {
          this.authenticateUser();
        }, 300); // register listeners take some time we can not mesure
      }
    },
    openModal() {
      this.openModalLoginRefused = true;
    },
    closeModal() {
      this.openModalLoginRefused = false;
      this.errorMessage = undefined;
    },
    showSericeErrorMsg() {
      Swal.fire({
        title: "Erro",
        text: "Não foi possível realizar o login. Tente novamente em alguns minutos.",
        showCancelButton: this.credentials.length > 0,
        confirmButtonText: "OK",
        cancelButtonText: "Ver credencial offline",
        allowEscapeKey: false,
        allowOutsideClick: false
      }).then(result => {
        if (result.isConfirmed) {
          this.invalidUser = false;
          this.invalidPwd = false;
        } else {
          this.$router.push("/offlinecredential");
        }
      });
    },
    async handleAuthenticatedUser() {
      if (!navigator.onLine) {
        globalThis.window.dispatchEvent(new Event("offline"));
        return;
      }
      this.isLoading = true;
      this.$root.$emit("show-loading");
      try {
        await this.tryRefreshAuthenticatedContext();
      } finally {
        this.isLoading = false;
        this.$root.$emit("hide-loading");
      }
    },
    async tryRefreshAuthenticatedContext() {
      let tentativa = 0;
      while (tentativa++ <= 5) {
        try {
          const nextRoute = await this.refreshContext();
          if (nextRoute !== "" && nextRoute !== ROTA_PADRAO) {
            await this.$router.replace(nextRoute);
            break;
          }
        } catch (error) {
          console.error(error);
          const shouldStop = this.handleRefreshContextError(error, tentativa);
          if (shouldStop) break;
        }
      }
    },
    handleRefreshContextError(error, tentativa) {
      if (error.error === "mfa_required") {
        const mfaKey = error.response?.headers;
        this.getInfosMFA(mfaKey);
        this.$router.push("/verification");
        return true;
      }
      if (!error.display || tentativa >= 5) {
        this.showSericeErrorMsg();
        return true;
      }
      return false;
    },
    showLoginDisplayError(error) {
      Swal.fire({
        title: "Aviso",
        text: error.message,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Tentar novamente",
        denyButtonText: "Recuperar senha",
        cancelButtonText: "Primeiro acesso",
        allowEscapeKey: false,
        allowOutsideClick: false
      }).then(result => {
        if (result.isConfirmed) {
          this.invalidUser = true;
          this.invalidPwd = true;
        } else if (result.isDenied) {
          this.$router.push("/forgot/reset");
        } else {
          this.$router.push("/first-access/terms");
        }
      });
    },
    handleLoginError(error) {
      if (error.error === "403") {
        this.openModalLoginRefused = true;
        this.errorMessage = error.message;
        return;
      }
      if (error.display) {
        this.showLoginDisplayError(error);
        return;
      }
      if (error.error === "mfa_required") {
        const mfaKey = error.response?.headers;
        this.getInfosMFA(mfaKey);
        this.$router.push("/verification");
        return;
      }
      this.showSericeErrorMsg();
    },
    async redirectAuthenticatedUser(nextRoute) {
      this.setUserAuthenticationState(true);
      if (this.shoudUseBiometric) {
        this.setAuthenticated();
      }
      if (!nextRoute.startsWith("/")) {
        await this.LOGOUT_USER();
        globalThis.window.location = nextRoute;
        return;
      }
      await this.redirectToInternalRoute(nextRoute);
    },
    async redirectToInternalRoute(nextRoute) {
      if (!this.hasValidNextUrl) {
        await this.$router.replace(nextRoute);
        return;
      }
      if (nextRoute === ROTA_VINCULOS || nextRoute === ROTA_OPTIN) {
        await this.$router.replace({
          path: nextRoute,
          query: {
            nextUrl: this.$route.query.nextUrl
          }
        });
        return;
      }
      await this.$router.replace(this.$route.query.nextUrl);
    },
    async login() {
      if (!navigator.onLine) {
        globalThis.window.dispatchEvent(new Event("offline"));
        return;
      }
      if (!this.input.username || !this.input.password) return;

      this.isLoading = true;
      this.$root.$emit("show-loading");
      let nextRoute = "";
      try {
        nextRoute = await this.loginUser(this.input);
      } catch (error) {
        console.error(error);
        this.handleLoginError(error);
      } finally {
        this.isLoading = false;
        this.$root.$emit("hide-loading");
      }
      if (nextRoute !== "" && nextRoute !== ROTA_PADRAO) await this.redirectAuthenticatedUser(nextRoute);
    },
    checkEnter() {
      if (this.input.username !== "" && this.input.password !== "") {
        this.login();
      }
    },
    toLowerCase() {
      this.input.username = this.input.username?.trim()?.toLowerCase();
    },
    getInfosMFA(resp) {
      this.SET_MFA_INFOS({
        mfa_key: resp["x-mfa-key"],
        mfa_email: resp["x-mfa-email"],
        username: this.input.username,
        password: this.input.password,
        telefone: resp["x-mfa-celular"]
      });
    }
  },
  components: {
    InstallPWA,
    LoginRefused
  }
};
</script>
<style scoped>
.page {
  position: fixed;
  inset: 0;
  overflow-y: auto;
  overscroll-behavior: none;
}

.cover {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form {
  width: 100%;
  max-width: 490px;
  box-sizing: border-box;
  padding: 40px 24px;
  background: #fff;
}

.form-group {
  display: flex;
  align-items: center;
  position: relative;
}

.required {
  display: none;
  position: absolute;
  right: 0;
  color: #968b83;
  font-size: 12px;
}

.InputLogin::placeholder {
  font-size: 14px;
}

@media (min-width: 992px) {
  .page {
    background: #e5e5e5;
  }

  .form {
    padding: 95px;
    border-radius: 1rem;
  }
}
</style>
